import React, { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
//Antd
import { Typography, Button, Tooltip, Popconfirm, Spin } from "antd";
import { Col, Divider, Row, Table, notification } from "antd";

import {
  DownloadOutlined,
  CheckOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
// import moment from "moment";
import {
  obtenerPostulacion,
  setUpdatePostulacion,
  cleanMensajeExito,
  cleanMensajeError,
  cleanbtnBandera,
  limpiaSistemaBandera,
} from "../../../redux/postulaciones/postulacionesDucks";
import { Link } from "react-router-dom";
import { linksRouter } from "../../../config/RouterLink";
// import { DATE_FORMAT_EXP } from "../../../utils/constantes";
import {
  descargarAcusePostulacion,
  setEstatusPeticionAcuse,
} from "../../../redux/postulaciones/AcuseDucks";
import { getBloqueoExpediente } from "../../../redux/aspirante/bloquearAspiranteDucks";

import './PostulacionesPage.css';

const { Text } = Typography;

export const PostulacionesPage = () => {
  const dispacth = useDispatch();
  const store = useStore();

  const { listPostula, mensajeError, mensajeExito, loading } = useSelector(
    (state) => state.postulacion
  );
  const acusePostulacionStore = useSelector(
    (state) => state.acusePostulacionStore
  );

  const { nombre, apellidos, correo } = useSelector(
    (state) => state.usuarioLogin
  );

  const lista = listPostula.map((item, i) => ({ ...item, key: i + 1 }));

  useEffect(() => {
    return () => {
      dispacth(limpiaSistemaBandera());
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //Se obtiene el bloqueo por el número de postulaciones o por fechas del concurso
    dispacth(getBloqueoExpediente(3));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispacth(obtenerPostulacion());
  }, [dispacth]);

  useEffect(() => {
    if (store.getState().postulacion.listPostula !== null) {
      dispacth(cleanbtnBandera());
    }
    // eslint-disable-next-line
  }, [store.getState().postulacion.listPostula]);

  useEffect(() => {
    if (mensajeExito) {
      notification.success({ description: mensajeExito });
      dispacth(cleanMensajeExito());
      dispacth(obtenerPostulacion());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mensajeExito]);

  useEffect(() => {
    if (mensajeError) {
      notification.warning({ description: mensajeError });
      dispacth(cleanMensajeError());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mensajeError]);

  const confirmarAccion = (aspiranteId, concursoId, convocatoriaId, folio) => {
    let dataJson = {
      idAspirante: aspiranteId,
      idConcurso: concursoId,
      idConvocatoria: convocatoriaId,
      idTipoConfirma: 1,
      usuario: correo,
      nombresApellidos: nombre + " " + apellidos,
      folio: folio,
    };

    dispacth(setUpdatePostulacion(dataJson));
  };

  /**
   * Función que permite bloquear el botón de expediente digital de acuerdo a las fechas de inicio y fin de captura de los documentos.
   * @param {Object} row
   * @returns True or False
   */
  // const isDisable = (row) => {
  //   const { fechaInicio, fechaFin } = row;
  //   const hoy = new Date(moment().format(DATE_FORMAT_EXP));
  //   const startDate = new Date(moment(fechaInicio).format(DATE_FORMAT_EXP));
  //   const endDate = new Date(moment(fechaFin).format(DATE_FORMAT_EXP));

  //   //Si la fecha actual es menor a la fecha inicio se bloquea el botón
  //   if (hoy < startDate) return true;
  //   //Si la fecha actual es igual o mayor a la fecha inicio y no existe fecha fin se habilita el botón
  //   if (hoy >= startDate && isNaN(endDate.getTime())) {
  //     return false;
  //   }
  //   //Si la fecha actual se encuentra en el rango de las fechas inicio y fin se habilita el botón
  //   //Si ya pasaron las fechas y el estatus se encuentra en uno solo se bloquea el botón
  //   // return hoy >= startDate && hoy <= endDate ? false : true;
  //   return hoy >= startDate ||  hoy >= endDate? false : true;
  // };

  // const rechazarAccion = (aspiranteId, concursoId, convocatoriaId) => {
  //   let dataJson = {
  //     idAspirante: aspiranteId,
  //     idConcurso: concursoId,
  //     idConvocatoria: convocatoriaId,
  //     idTipoConfirma: 2,
  //     usuario: correo,
  //   };

  //   dispacth(setUpdatePostulacion(dataJson));
  // };

  const columns = [
    {
      title: (
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#333333",
          }}
        >
          Número de Folio
        </Text>
      ),
      dataIndex: "folio",
      key: "folio",
      render: (value, data) => {
        return (
          <>
            {Number(data.idEstatusProceso) === 1 &&
              Number(data.idTipoConfirma) !== 0 && <p>{`${data.folio}`}</p>}
          </>
        );
      },

      width: "200px",
    },
    {
      title: (
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#333333",
          }}
        >
          Concurso
        </Text>
      ),
      dataIndex: "nombreConcurso",
      key: "nombreConcurso",
      render: (value, data) => {
        return (
          <>
            <p>{`${data.nombreConcurso}`}</p>
          </>
        );
      },
    },
    {
      title: (
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#333333",
          }}
        >
          Convocatoria
        </Text>
      ),
      dataIndex: "nombreConvocatoria",
      key: "nombreConvocatoria",
      render: (value, data) => {
        return (
          <>
            <p>{`${data.nombreConvocatoria}`}</p>
          </>
        );
      },
    },
    {
      title: (
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#333333",
          }}
        >
          Vacante
        </Text>
      ),
      dataIndex: "nombreTipo",
      key: "nombreTipo",
      render: (value, data) => {
        return (
          <>
            <p>{`${
              data.denominacion ? data.denominacion : data.nombreTipo
            }`}</p>
          </>
        );
      },
    },
    {
      title: (
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#333333",
          }}
        >
          Estatus
        </Text>
      ),
      dataIndex: "estatusDescarte",
      key: "estatusDescarte",
      render: (value, data) => {
        return (
          <>
            <p>{`${data.estatusDescarte}`}</p>
          </>
        );
      },
    },
    {
      title: (
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#333333",
          }}
        >
          Observaciones
        </Text>
      ),
      dataIndex: "observaciones",
      key: "observaciones",
      render: (value, data) => {
        return (
          <>
            <p>{`${data.observaciones}`}</p>
          </>
        );
      },
    },
    {
      title: (
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#333333",
          }}
        >
          Acciones
        </Text>
      ),
      // dataIndex: "estatusDescarte",
      key: "Acciones",
      align: "center",
      width: "110px",
      render: (value, record, index) => (
        <Row gutter={24}>
          {Number(value.idEstatusProceso) === 1 &&
            Number(value.confirmaBand) === 1 &&
            Number(value.idTipoConfirma) === 0 && (
              <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                <Popconfirm
                  placement="bottom"
                  title="¿Desean confirmar la asistencia?"
                  onConfirm={() =>
                    confirmarAccion(
                      value.idAspirante,
                      value.idConcurso,
                      value.idConvocatoria,
                      value.folio
                    )
                  }
                  okText="Si"
                  cancelText="No"
                  disabled={Number(value.activaConfirmacion) === 0}
                >
                  <Tooltip placement="top" title="Confirmar">
                    <Button
                      size={"middle"}
                      type="primary"
                      shape="circle"
                      style={{ marginRight: "5px" }}
                      disabled={Number(value.activaConfirmacion) === 0}
                      icon={<CheckOutlined />}
                    >
                      {/* Confirmar */}
                    </Button>
                  </Tooltip>
                </Popconfirm>
              </Col>
            )}
          {/* 
          {Number(value.idEstatusProceso) === 1 &&
            Number(value.confirmaBand) === 1 && (
              <Popconfirm
                placement="bottom"
                title="¿Deseas rechazar la asistencia a la postulación?"
                onConfirm={() =>
                  rechazarAccion(
                    value.idAspirante,
                    value.idConcurso,
                    value.idConvocatoria
                  )
                }
                okText="Si"
                cancelText="No"
                disabled={Number(value.activaConfirmacion) === 0}
              >
                <Tooltip placement="top" title="Rechazar">
                  <Button
                    size={"middle"}
                    type="primary"
                    style={{ marginRight: "5px" }}
                    disabled={Number(value.activaConfirmacion) === 0}
                  >
                    Rechazar
                  </Button>
                </Tooltip>
              </Popconfirm>
            )}
          */}
          {/* <Divider type="vertical" /> */}
          <Col
            span={8}
            xxl={8}
            xl={8}
            lg={8}
            md={8}
            sm={24}
            xs={24}
            hidden={
              Number(value.idEstatusProceso) !== 1 ||
              Number(value.idTipoConfirma) === 0
            }
          >
            <Tooltip title={"Descargar acuse"}>
              <Button
                size={"middle"}
                onClick={() => descargarAcuse(record)}
                //className="btn-postulaciones-acciones"
                type="primary"
                // style={{ marginRight: "5px" }}
                shape="circle"
                icon={<DownloadOutlined />}
                disabled={
                  Number(value.idEstatusProceso) !== 1 ||
                  Number(value.idTipoConfirma) === 0
                }
              />
            </Tooltip>
          </Col>

          {/* ---------------------- Expediente Digital -------------------------- */}
          {/* {value.idEstatus === 1 && value.estatusDescarte === "Aprobado" && ( */}
          {value.estatusDescarte === "Aprobado" && (
            <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Tooltip title="Expediente digital">
                <Link
                  to={{
                    pathname: linksRouter.expediente,
                    aspirante: {
                      idConvocatoria: value.idConvocatoria,
                      idConcurso: value.idConcurso,
                      idEstatus: value.idEstatus,
                    },
                  }}
                  // disabled={isDisable(value)}
                  disabled={value.calificacion !== 1}
                >
                  <Button
                    size="middle"
                    type="primary"
                    // disabled={value.idEstatusProceso !== 1}
                    // disabled={isDisable(value)}
                    
                    hidden={value.calificacion !== 1}
                    shape="circle"
                    icon={<FileTextOutlined />}
                  >
                    {/* Expediente */}
                  </Button>
                </Link>
              </Tooltip>
            </Col>
          )}
        </Row>
      ),
    },
  ];

  //USE EFFECT -> Después de generar el acuse se crea el click oculto para la descarga y muestra la notificacion correspondiente
  useEffect(() => {
    if (
      acusePostulacionStore.terminaAcusePostulacion !== undefined &&
      acusePostulacionStore.terminaAcusePostulacion !== null
    ) {
      if (acusePostulacionStore.terminaAcusePostulacion) {
        if (acusePostulacionStore.acusePostulacion.estatus !== 0) {
          if (acusePostulacionStore.acusePostulacion.estatus === 1) {
            notification.success({
              message: "Acuse de postulación",
              description: "Acuse generado satisfactoriamente.",
            });
          }
          if (acusePostulacionStore.acusePostulacion.estatus === 2) {
            notification.warning({
              message: "Acuse de postulación",
              description:
                "No se encontraron las imágenes necesarias para el reporte.",
            });
          }
          const link = document.createElement("a");
          link.href =
            "data:content/unknow;base64," +
            acusePostulacionStore.acusePostulacion.base64;
          link.download = acusePostulacionStore.acusePostulacion.nombre;
          link.click();
          link.remove();
        } else {
          notification.warning({
            message: "Acuse de postulación",
            description: "No se encontraron registros para el reporte.",
          });
        }
      } else {
        notification.error({
          message: "Acuse de postulación",
          description: acusePostulacionStore.error.mensaje,
        });
      }

      dispacth(
        setEstatusPeticionAcuse({
          bandera: null,
          error: { mensaje: null, estatus: null },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acusePostulacionStore.terminaAcusePostulacion]);

  //Función para llamar la descarga del reporte de Acuse de postulación
  const descargarAcuse = (record) => {
    let data = {
      idAspirante: record.idAspirante + "",
      folio: record.folio.trim(),
      fechaPostulacion: record.fhPostulacion + "",
    };
    dispacth(descargarAcusePostulacion(data));
  };

  return (
    <>
      <div className="contenedorMisVacantes">
        <Spin spinning={acusePostulacionStore.loadingAcusePostulacion}>
          <Row>
            <Col span={24}>
              <h1 className="titulo-color">Mis postulaciones</h1>
              <Divider id="titulo-divider" />
            </Col>
          </Row>

          <div>
            <Table
              columns={columns}
              pagination={false}
              dataSource={lista}
              loading={loading}
              scroll={{ x: true }}
            />
          </div>
        </Spin>
      </div>
    </>
  );
};
